import React from 'react'; 
import '../../assets/css/PrintFoodReserveSummary.css';
import { ReserveStatus } from '../Reserve/ReserveStatus';

export const PrintFoodReserveSummary = ({ reserve, foods }) => {

    // 1. اطلاعات اصلی
    const primaryUser = (reserve.reserve_Users || []).find(x => x.isPrimary) || {};
    
    // 2. گروه‌بندی غذاها بر اساس تاریخ
    const foodsByDate = foods.reduce((acc, food) => {
        if (food.count <= 0) return acc;
        
        const dateKey = food.date_Shamsi;
        if (!acc[dateKey]) {
            acc[dateKey] = {
                date: food.date_Shamsi,
                dayOfWeek: food.dayOfWeek,
                lunchItems: [],
                dinnerItems: [],
                lunchMealName: '',
                dinnerMealName: ''
            };
        }
        
        // تشخیص وعده غذایی و ذخیره نام وعده
        const isLunch = food.persionFoodSection.includes('ناهار') || 
                       food.persionFoodSection.includes('نهار') ||
                       food.persionFoodSection.includes('سحری') ||
                       food.persionFoodSection.includes('صبحانه');
        
        const item = {
            title: food.foodTitle,
            count: food.count
        };
        
        if (isLunch) {
            acc[dateKey].lunchItems.push(item);
            if (!acc[dateKey].lunchMealName) {
                acc[dateKey].lunchMealName = food.persionFoodSection;
            }
        } else {
            acc[dateKey].dinnerItems.push(item);
            if (!acc[dateKey].dinnerMealName) {
                acc[dateKey].dinnerMealName = food.persionFoodSection;
            }
        }
        
        return acc;
    }, {});
    
    // 3. تابع برای مرتب‌سازی تاریخ شمسی
    const sortShamsiDates = (a, b) => {
        const toNumber = (dateStr) => {
            const parts = dateStr.split('/');
            if (parts.length !== 3) return 0;
            
            const year = parseInt(parts[0]) || 0;
            const month = parseInt(parts[1]) || 0;
            const day = parseInt(parts[2]) || 0;
            
            return year * 10000 + month * 100 + day;
        };
        
        return toNumber(a.date) - toNumber(b.date);
    };
    
    // 4. تبدیل به آرایه و مرتب‌سازی
    const sortedDates = Object.values(foodsByDate)
        .sort(sortShamsiDates)
        .map(dayData => ({
            ...dayData,
            lunchMealName: dayData.lunchMealName || 'ناهار',
            dinnerMealName: dayData.dinnerMealName || 'شام'
        }));
    
    // 5. محاسبه جمع کل
    const totalCount = foods.reduce((sum, food) => sum + food.count, 0);
    const roomNumber = reserve.objectInstance?.title || 'تعیین نشده';
    
    return (
        <div className="compact-print-container">
            {/* هدر */}
            <div className="footer-note">
                حسینیه نجف آبادیها (مشهد مقدس)
            </div>

            <div className="compact-header">
                <div className="header-main">
                    <div className="title-row">
                        <div className="title">برگه تحویل غذا</div>
                        <div className="tracking-code">شماره پذیرش: {reserve.trackingCode}</div>
                    </div>
                    
                    <div className="info-block">
                        <div className="info-row">
                            <div className="info-item">
                                <span className="info-label">نام میهمان:</span>
                                <span className="info-value bold">{reserve.fullName}</span>
                            </div>
                            {primaryUser?.nationalCode && (
                                <div className="info-item">
                                    <span className="info-label">کد ملی:</span>
                                    <span className="info-value">{primaryUser.nationalCode}</span>
                                </div>
                            )}
                        </div>
                        
                        <div className="info-row">
                            <div className="info-item">
                                <span className="info-label">تاریخ ورود:</span>
                                <span className="info-value">{reserve.from_Shamsi_DayOfWeek} {reserve.from_Shamsi}</span>
                            </div>
                            <div className="info-item">
                                <span className="info-label">تاریخ خروج:</span>
                                <span className="info-value">{reserve.to_Shamsi_DayOfWeek} {reserve.to_Shamsi}</span>
                            </div>
                        </div>
                        
                        <div className="info-row">
                            <div className="info-item">
                                <span className="info-label">تعداد نفرات:</span>
                                <span className="info-value bold">{reserve.reserve_Users.length} نفر</span>
                            </div>
                            <div className="info-item">
                                <span className="info-label">اتاق:</span>
                                <span className="info-value bold room-number">{roomNumber}</span>
                            </div>
                            <div className="info-item">
                                <span className='info-label'>
                                    <ReserveStatus reserveStatus={reserve.reserveStatus} />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* جدول اصلی */}
            <div className="foods-table-container">
                <table className="eight-column-table">
                    
    {/* 🔴 کنترل واقعی عرض ستون‌ها */}
    <colgroup>
        <col style={{ width: '8%' }} />   {/* میز ناهار */}
        <col style={{ width: '10%' }} />  {/* تاریخ ناهار */}
        <col style={{ width: '22%' }} />  {/* غذا ناهار */}
        <col style={{ width: '5%' }} />   {/* تعداد ناهار */}

        <col style={{ width: '8%' }} />   {/* میز شام */}
        <col style={{ width: '10%' }} />  {/* تاریخ شام */}
        <col style={{ width: '22%' }} />  {/* غذا شام */}
        <col style={{ width: '5%' }} />   {/* تعداد شام */}
    </colgroup>
                    <thead>
                        <tr>
                            <th className="col-lunch-header" colSpan="4">{sortedDates[0]?.lunchMealName || 'ناهار'}</th>
                            <th className="col-dinner-header" colSpan="4">{sortedDates[0]?.dinnerMealName || 'شام'}</th>
                        </tr>
                        <tr className="sub-headers">
                            <th className="col-miz">میز</th>
                            <th className="col-date">تاریخ / روز</th>
                            <th className="col-food-name">نام غذا</th>
                            <th className="col-food-count">تعداد</th>
                            <th className="col-miz">میز</th>
                            <th className="col-date">تاریخ / روز</th>
                            <th className="col-food-name">نام غذا</th>
                            <th className="col-food-count">تعداد</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedDates.map((dayData, index) => {
                            const maxRows = Math.max(
                                dayData.lunchItems.length, 
                                dayData.dinnerItems.length,
                                1
                            );
                            
                            return (
                                <React.Fragment key={dayData.date}>
                                    {Array.from({ length: maxRows }).map((_, rowIndex) => (
                                        <tr key={`${dayData.date}-${rowIndex}`} className="food-row">
                                            {/* سمت چپ - وعده اول */}
                                            
                                            {/* ستون شماره میز سمت چپ */}
                                            {rowIndex === 0 ? (
                                                <td className="col-miz" rowSpan={maxRows}>
                                                    <div className="miz-number">
                                                        {/* {index + 1} */}
                                                    </div>
                                                </td>
                                            ) : null}
                                            
                                            {/* ستون تاریخ سمت چپ */}
                                            {rowIndex === 0 ? (
                                                <td className="col-date" rowSpan={maxRows}>
                                                    <div className="date-cell">
                                                        <div className="week-day">{dayData.dayOfWeek}</div>
                                                        <div className="shamsi-date">{dayData.date}</div>
                                                        <div className="meal-name">{dayData.lunchMealName}</div>
                                                    </div>
                                                </td>
                                            ) : null}
                                            
                                            {/* نام غذا سمت چپ */}
                                            <td className="col-food-name">
                                                {rowIndex < dayData.lunchItems.length ? (
                                                    <div className="food-item">
                                                        {dayData.lunchItems[rowIndex].title}
                                                    </div>
                                                ) : null}
                                            </td>
                                            
                                            {/* تعداد غذا سمت چپ */}
                                            <td className="col-food-count">
                                                {rowIndex < dayData.lunchItems.length ? (
                                                    <div className="count-value">
                                                        {dayData.lunchItems[rowIndex].count}
                                                    </div>
                                                ) : null}
                                            </td>
                                            
                                            {/* سمت راست - وعده دوم */}
                                            
                                            {/* ستون شماره میز سمت راست */}
                                            {rowIndex === 0 ? (
                                                <td className="col-miz" rowSpan={maxRows}>
                                                    <div className="miz-number">
                                                        {/* {index + 1} */}
                                                    </div>
                                                </td>
                                            ) : null}
                                            
                                            {/* ستون تاریخ سمت راست */}
                                            {rowIndex === 0 ? (
                                                <td className="col-date" rowSpan={maxRows}>
                                                    <div className="date-cell">
                                                        <div className="week-day">{dayData.dayOfWeek}</div>
                                                        <div className="shamsi-date">{dayData.date}</div>
                                                        <div className="meal-name">{dayData.dinnerMealName}</div>
                                                    </div>
                                                </td>
                                            ) : null}
                                            
                                            {/* نام غذا سمت راست */}
                                            <td className="col-food-name">
                                                {rowIndex < dayData.dinnerItems.length ? (
                                                    <div className="food-item">
                                                        {dayData.dinnerItems[rowIndex].title}
                                                    </div>
                                                ) : null}
                                            </td>
                                            
                                            {/* تعداد غذا سمت راست */}
                                            <td className="col-food-count">
                                                {rowIndex < dayData.dinnerItems.length ? (
                                                    <div className="count-value">
                                                        {dayData.dinnerItems[rowIndex].count}
                                                    </div>
                                                ) : null}
                                            </td>
                                        </tr>
                                    ))}
                                    
                                    {/* خط جداکننده بین روزها */}
                                    {index < sortedDates.length - 1 && (
                                        <tr className="day-separator">
                                            <td colSpan="8" className="separator-cell"></td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            
            {/* امضاءها */}
            <div className="compact-footer">
                <div className="signatures-compact">
                    <table className="signature-table-compact">
                        <tbody>
                            <tr className="signature-lines">
                                <td className="signature-cell">
                                    <div className="signature-label">امضاء پذیرش</div>
                                </td>
                                {/* <td className="signature-cell">
                                    <div className="signature-line"></div>
                                    <div className="signature-label">امضاء مسئول تحویل غذا</div>
                                </td>
                                <td className="signature-cell">
                                    <div className="signature-line"></div>
                                    <div className="signature-label">امضاء میهمان</div>
                                </td> */}
                                <td className="signature-cell">
                                    <div className="signature-label">
                    چاپ شده در تاریخ: {new Date().toLocaleDateString('fa-IR')} ساعت: {new Date().toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' })}
                </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                {/* <div className="footer-note">
                    چاپ شده در تاریخ: {new Date().toLocaleDateString('fa-IR')} ساعت: {new Date().toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' })}
                </div> */}
            </div>
        </div>
    );
};